import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import SideMenuLayout from "../../../layouts/side-menu";
import { generateOtherMenu } from "../../../constants/other-menu";
import GwProductListModule from "../../../modules/gw-product/list";

const GwProductListPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const sideMenus = generateOtherMenu(t);

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/other-list",
          title: t("common.text.otherList"),
          isDisabled: true,
        },
        {
          link: "/gw-product",
          title: t("common.text.gwProduct"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t]);

  return (
    <>
      <VuiHelmet title={t("pages.gwProduct.list.metaTitle")} />

      <SideMenuLayout menus={sideMenus}>
        <GwProductListModule />
      </SideMenuLayout>
    </>
  );
};

export default GwProductListPage;
